﻿export function startPageData(state = [], action) {
    switch (action.type) {
        case 'STARTPAGE_LOADED':
            return action.data;

        default:
            return state;
    }
}

export function startPageAnimalPossessionQuoteData(state = [], action) {
    switch (action.type) {
        case 'ANIMAL_POSSESSION_QUOTES_LOADED':
            return action.quotes;

        default:
            return state;
    }
}